import {useEffect} from 'react';
import {Subject} from 'rxjs';
import config from '../config';
import useStore from './use-store';

let socket = null;

const {socketURL} = config;

const subjects$ = {
    devices: new Subject(),
    events: new Subject(),
    positions: new Subject(),
};

const _init = (token) => {
    const url = `${socketURL}?b=${token}`;
    socket = new WebSocket(url);

    socket.onopen = () => console.log(`Conectando socket`);

    socket.onmessage = ({data}) => {
        const [event, values] = Object.entries(JSON.parse(data))[0];
        subjects$[event].next(values);
    };

    socket.onclose = () => {
        console.log('Socket has disconnected!');
        setTimeout(() => _init(token), 60 * 1000);
    };

    socket.onerror = (err) => console.error('Socket error: ', err);
};

const useSocket = () => {
    const {store} = useStore();
    const {auth} = store;

    useEffect(() => {
        if (!socket) _init(auth.token);
    }, [auth.token]);

    return subjects$;
};

export default useSocket;
